import type { NestedI18nObject } from '../../utils';

const common: NestedI18nObject = {
  // Layout
  layouts: {
    userLayout: {
      title: 'Ant Design is the most influential web design specification in Xihu district',
    },
  },

  // Login Page
  login: {
    accountLogin: {
      tab: 'Account Login',
      errorMessage: 'Incorrect username/password(admin/ant.design)',
    },
    failure: 'Login failed, please try again!',
    success: 'Login successful!',
    username: {
      placeholder: 'Username: admin or user',
      required: 'Please input your username!',
    },
    password: {
      placeholder: 'Password: ant.design',
      required: 'Please input your password!',
    },
    phoneLogin: {
      tab: 'Phone Login',
      errorMessage: 'Verification Code Error',
      getVerificationCode: 'Get Code',
    },
    phoneNumber: {
      placeholder: 'Phone Number',
      required: 'Please input your phone number!',
      invalid: 'Phone number is invalid!',
    },
    captcha: {
      placeholder: 'Verification Code',
      required: 'Please input verification code!',
    },
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot Password ?',
    submit: 'Login',
    loginWith: 'Login with :',
    registerAccount: 'Register Account',
  },

  // Common captcha text
  getCaptchaSecondText: 'sec(s)',

  // Welcome Page
  welcome: {
    link: 'Welcome',
    alertMessage: 'Faster and stronger heavy-duty components have been released.',
  },

  // 404 Page
  '404': {
    subTitle: 'Sorry, the page you visited does not exist.',
    buttonText: 'Back Home',
  },
};

export default common;
